<template lang="pug">
  v-dialog(v-model='dialogImportacionExpediente' scrollable persistent max-width='80%')
    v-card
      v-card-text
        v-container(id="expediente")
          table(width='100%' cellspacing="0" align="center" style="padding: 0px 3px 3px 3px")
            tr
              td(align="center")
                label(style="color: black; font-weight: bold; font-size: 15px") EXPEDIENTE #
                label(style="color: black; font-weight: bold; font-size: 15px") {{datos.nroExpediente}} / {{fechaActual}}
          p
          table(border="0" align="center" width='100%')
            tr.letra
              table(width='100%' cellspacing="0" align="center" style="padding: 0px 3px 3px 3px")
                tr(style="font-size: 11px;")
                  td(colspan='3' style="border:1px solid black; padding: 0px 4px 0px 4px;")
                    label(style='font-weight: bold') SHIPPER/EXPORTER: 
                    label(v-if="datos.shipper && datos.shipper.nombre") {{datos.shipper.nombre}}
                  td(style="border:1px solid black; padding: 0px 4px 0px 4px;" width='25%' valign='top')
                    label(style='font-weight: bold') BOOKING NRO: 
                    label(v-if="datos.bookingNaviera") {{datos.bookingNaviera}}
                  td(style="border:1px solid black; padding: 0px 4px 0px 4px;" width='25%' valign='top')
                    label(style='font-weight: bold') BILL OF LADING NRO: 
                    label(v-if="datos.bl") {{datos.bl}}
                tr(style="font-size: 11px;")
                  td(valign='top' colspan='3' rowspan="2" style="border:1px solid black;padding: 0px 4px 0px 4px")
                    label(style='font-weight: bold') CONSIGNEE / NOTIFY PARTY: 
                    label(v-if="datos.consignee && datos.consignee.nombreEmpresa") {{datos.consignee.nombreEmpresa}}
                  td(valign='top' colspan='2' style="border:1px solid black; padding: 0px 4px 0px 4px")
                    label(style='font-weight: bold') FORWARDING AGENT: 
                    label(v-if="datos.agencia && datos.agencia.nombreEmpresa") {{datos.agencia.nombreEmpresa}}
                tr(style="font-size: 11px;")
                  td(style="border:1px solid black; padding: 0px 4px 0px 4px" width='25%' valign='top')
                    label(style='font-weight: bold') NAVIERA: 
                    label(v-if="datos.naviera && datos.naviera.nombreEmpresa") {{datos.naviera.nombreEmpresa}}
                  td(style="border:1px solid black; padding: 0px 4px 0px 4px" width='25%' valign='top')
                    label(style='font-weight: bold') USO: 
                    label(v-if="datos.uso") {{datos.uso}}
                tr(style="font-size: 11px;")
                  td(align="center" style="border:1px solid black; padding: 0px 4px 0px 4px" valign='top')
                    label(style="font-weight: bold") ETD 1
                  td(align="center" style="border:1px solid black; padding: 0px 4px 0px 4px" valign='top')
                    label(style="font-weight: bold") ETA 1
                  td(align="center" style="border:1px solid black; padding: 0px 4px 0px 4px" valign='top')
                    label(style="font-weight: bold") ETD 2
                  td(align="center" style="border:1px solid black; padding: 0px 4px 0px 4px" valign='top')
                    label(style="font-weight: bold") ETA 2
                  td(align="center" style="border:1px solid black; padding: 0px 4px 0px 4px" valign='top')
                    label(style="font-weight: bold") ETA 3
                tr(style="font-size: 11px;")
                  td(align="start" style="border:1px solid black; padding: 0px 4px 0px 4px" valign='top')
                    label(style="font-weight: bold") VESSEL / VOY
                  td(align="start" style="border:1px solid black; padding: 0px 4px 0px 4px" valign='top')
                    label(style="font-weight: bold") PORT OF DISCHARGE
                  td(align="start" style="border:1px solid black; padding: 0px 4px 0px 4px" valign='top')
                    label(style="font-weight: bold") PORT OF LOADING
                  td(align="start" style="border:1px solid black; padding: 0px 4px 0px 4px" valign='top')
                    label(style="font-weight: bold") VESSEL / VOY
                  td(align="start" style="border:1px solid black; padding: 0px 4px 0px 4px" valign='top')
                    label(style='font-weight: bold') STORE:  
                    label(v-if="datos.fechaETA3 && datos.fechaETA3 !==''") {{datos.almacenLlegada}}
                tr(style="font-size: 11px;") 
                  td(align="start" style="border:1px solid black; padding: 0px 4px 0px 4px" valign='top')
                    label(v-if="datos.barco && datos.nroViaje" ) {{datos.barco}} / {{datos.nroViaje}}
                  td(align="start" style="border:1px solid black; padding: 0px 4px 0px 4px" valign='top')
                    label(v-if="datos.paisETA1") {{datos.paisETA1.pais}},  
                    label(v-if="datos.puertoETA1 !== 'null'") {{datos.puertoETA1}}
                  td(align="start" style="border:1px solid black; padding: 0px 4px 0px 4px" valign='top')
                    label(v-if="datos.paisETA1") {{datos.paisETA1.pais}},  
                    label(v-if="datos.puertoETA1 !== 'null'") {{datos.puertoETA1}}
                  td(align="start" style="border:1px solid black; padding: 0px 4px 0px 4px" valign='top')
                    label(v-if="datos.atraque") {{datos.atraque.barco}} / {{datos.atraque.nroViaje}}
                  td(align="start" style="border:1px solid black; padding: 0px 4px 0px 4px" valign='top')
                    label(style='font-weight: bold') DATE / (ETA 2 - ETA 3): 
                    label(v-if="datos.fechaETA3 && datos.fechaETA3 !==''") {{datos.fechaETA3}} / 
                    label(v-if="datos.diasETA2ETA3 && datos.diasETA2ETA3 > 0" style='font-weight: bold') {{datos.diasETA2ETA3}}
                tr(style="font-size: 11px;") 
                  td(align="start" style="border:1px solid black; padding: 0px 4px 0px 4px" valign='top')
                    label(style='font-weight: bold') PORT OF LOADING
                  td(align="start" style="border:1px solid black; padding: 0px 4px 0px 4px" valign='top')
                    label(style='font-weight: bold') DATE / (ETD 1 - ETA 1)
                  td(align="start" style="border:1px solid black; padding: 0px 4px 0px 4px" valign='top')
                    label(style='font-weight: bold') DATE / (ETA 1 - ETD 2)
                  td(align="start" style="border:1px solid black; padding: 0px 4px 0px 4px" valign='top')
                    label(style='font-weight: bold') PORT OF DELIVERY
                  td(align="start" style="border:1px solid black; padding: 0px 4px 0px 4px" valign='top')
                    label(v-if="datos.transito && datos.transito !==''" style='font-weight: bold') TOTAL DAYS: {{datos.transito}}
                tr(style="font-size: 11px;") 
                  td(align="start" style="border:1px solid black; padding: 0px 4px 0px 4px" valign='top')
                    label(v-if="datos.paisETD1") {{datos.paisETD1.pais}}, 
                    label(v-if="datos.puertoETD1 !== 'null'") {{datos.puertoETD1}}
                  td(align="start" style="border:1px solid black; padding: 0px 4px 0px 4px" valign='top')
                    label(v-if="datos.fechaETA1 && datos.fechaETA1 !==''") {{datos.fechaETA1}} / 
                    label(v-if="datos.diasETD1ETA1 && datos.diasETD1ETA1 > 0" style='font-weight: bold') {{datos.diasETD1ETA1}}
                  td(align="start" style="border:1px solid black; padding: 0px 4px 0px 4px" valign='top')
                    label(v-if="datos.fechaETD2 && datos.fechaETD2 !==''") {{datos.fechaETD2}} / 
                    label(v-if="datos.diasETA1ETD2 && datos.diasETA1ETD2 > 0" style='font-weight: bold') {{datos.diasETA1ETD2}}
                  td(align="start" style="border:1px solid black; padding: 0px 4px 0px 4px" valign='top')
                    label(v-if="datos.paisETA2") {{datos.paisETA2.pais}}, 
                    label(v-if="datos.puertoETA2 !== 'null'") {{datos.puertoETA2}}
                  td(align="start" style="border:1px solid black; padding: 0px 4px 0px 4px" valign='top')
                    label(style='font-weight: bold') DAYS OFF / NEGOTIABLE DAY: 
                    label {{datos.diasRestantes}} / {{datos.diasLibres}}
                tr(style="font-size: 11px;") 
                  td(align="start" style="border:1px solid black; padding: 0px 4px 0px 4px" valign='top')
                    label(style='font-weight: bold') DATE
                  td(align="start" style="border:1px solid black;border-bottom: 0px;border-right: 0px;padding: 0px 4px 0px 4px" valign='top')
                  td(align="start" style="border:1px solid black;border-bottom: 0px;border-left: 0px;padding: 0px 4px 0px 4px" valign='top')
                  td(align="start" style="border:1px solid black; padding: 0px 4px 0px 4px" valign='top')
                    label(style='font-weight: bold') DATE / (ETD 2 - ETA 2)
                  td(align="start" style="border:1px solid black;border-bottom: 0px; padding: 0px 4px 0px 4px" valign='top')
                tr(style="font-size: 11px;") 
                  td(align="start" style="border:1px solid black; padding: 0px 4px 0px 4px" valign='top')
                    label(v-if="datos.fechaETD1 && datos.fechaETD1 !==''" ) {{datos.fechaETD1}}
                  td(align="start" style="border:1px solid black;border-top: 0px;border-right: 0px; padding: 0px 4px 0px 4px" valign='top')
                  td(align="start" style="border:1px solid black;border-top: 0px;border-left: 0px; padding: 0px 4px 0px 4px" valign='top')
                  td(align="start" style="border:1px solid black; padding: 0px 4px 0px 4px" valign='top')
                    label(v-if="datos.fechaETA2 && datos.fechaETA2 !==''") {{datos.fechaETA2}} / 
                    label(v-if="datos.diasETD2ETA2 && datos.diasETD2ETA2 > 0" style='font-weight: bold') {{datos.diasETD2ETA2}}
                  td(align="start" style="border:1px solid black;border-top: 0px; padding: 0px 4px 0px 4px" valign='top')
            tr
              td
                h4(align="center" style="color: black") PARTICULARS FURNISHED BY SHIPPER
          table(border="1" width='100%' cellspacing="0" align="center")
            tr
              td(align="center" width='15%')
                div
                  span.header CONTAINER
              td(align="center" width='15%')
                div
                  span.header NRO OF PKGS
              td(align="start" style='padding: 0px 0px 0px 4px')
                div
                  span.header DESCRIPTION OF PACKAGES AND GOODS
              td(align="center" width='12%')
                div
                  span.header GROSS WEIGHT
              td(align="center" width='12%')
                div
                  span.header MEASUREMENT
            tr(v-for="(item, k) in datos.contenedores" :key="k" align='center')
              td(align="center" valign='top' style="padding: 5px; color: black; font-size: 11px;")
                div
                  span NRO: {{item.contenedorOrd}}
                div
                  span SEAL: {{item.selloOrd}}
              td(align="center" valign='top' style="padding: 5px; color: black; font-size: 11px;")
                div
                  span 1x40HQ
                div
                  //- colocar cartones
                  span {{item.piezasContenedorOrd}} CARTONS
              td(v-if="k === 0" :rowspan="valor" align='start' valign='top' style='padding: 0px 0px 0px 4px;color: black; font-size: 11px;')
                div
                  span {{datos.descripcionGeneralizada}}
              td(align="center" valign='top' style="padding: 5px; color: black; font-size: 11px;")
                div
                  span {{item.pesoContenedorOrd}} KGS
              td(align="center" valign='top' style="padding: 5px; color: black; font-size: 11px;")
                div
                  span {{item.piesCubicosContenedorOrd}} CBM
            tr
              td(align='right' style='color: black; font-size: 12px; font-weight: bold;')
                div
                  span(style='color: black; padding: 0px 4px 0px 0px;') TOTAL PACKAGE(S): 
              td(align='center' style='color: black; font-size: 12px; font-weight: bold;')
                div
                  span(style='color: black; padding: 0px 0px 0px 4px;') CARTONES
              td(align='right' style='color: black; font-size: 12px; font-weight: bold;')
                div
                  span(style='color: black; padding: 0px 4px 0px 0px;') TOTALES:
              td(align='center' style='color: black; font-size: 12px; font-weight: bold;')
                div
                  span(style='color: black; padding: 0px 0px 0px 4px;') {{(datos.kilogramosGeneralContenedor)}} KGS
              td(align='center' style='color: black; font-size: 12px; font-weight: bold;')
                div
                  span(style='color: black; padding: 0px 0px 0px 4px;') {{datos.piesCubicosGeneralContenedor}} CBM
            tr
              td(align='right' style='color: black; font-size: 12px; font-weight: bold;')
                div
                  span(style='color: black; padding: 0px 4px 0px 0px;') TOTAL CONTAINER(S): 
              td(align='center' style='color: black; font-size: 12px; font-weight: bold;')
                div
                  span(v-if='datos.contenedores' style='color: black; padding: 0px 0px 0px 4px;') {{datos.contenedores.length}}
              td(colspan='3' style='color: black;0')
          table(width='100%' cellspacing="0" align="center" style="padding: 0px 3px 3px 3px;'margin-top: -9px;")
            tr
              td
                h4(align="center" style="color: black; margin-top: 5px;") RESUMEN ORDENES DE COMPRA
          table(border="1" width='100%' cellspacing="0" align="center")
            tr
              td(align="center" width='8%')
                div
                  span.header #O-C
              td(align="start" style='padding: 0px 0px 0px 4px')
                div
                  span.header PROVEEDOR
              td(align="center")
                div
                  span.header DESCRIPCIÓN
              td(align="center" width='7%')
                div
                  span.header BULTOS
              td(align="center" width='8%')
                div
                  span.header PESO
              td(align="center" width='9%')
                div
                  span.header PIES CÚBICOS
              td(align="center" width='8%')
                div
                  span.header MONTO FOB
            tr(v-for="(item, k) in datos.importacion" :key="k" align='center')
              td(align="center" valign='top' style="padding: 5px; color: black; font-size: 11px;")
                div
                  span {{item.codigoOrd}}
              td(align="start" valign='top' style="padding: 5px; color: black; font-size: 11px;")
                div
                  span {{item.proveedorOrd.nombre}}
              td(align="start" valign='top' style="padding: 5px; color: black; font-size: 11px;")
                div
                  span {{item.descripcionProdOrd}}
              td(align="center" valign='top' style="padding: 5px; color: black; font-size: 11px;")
                div
                  span {{item.piezasOrd}}
              td(align="center" valign='top' style="padding: 5px; color: black; font-size: 11px;")
                div
                  span {{item.kilogramosOrd}} KGS
              td(align="center" valign='top' style="padding: 5px; color: black; font-size: 11px;")
                div
                  span {{item.piesCubicosOrd}} CBM
              td(align="center" valign='top' style="padding: 5px; color: black; font-size: 11px;")
                div
                  span $ {{item.totalOrd}}
          table(width='30%' cellspacing="0" align="start" style="padding: 0px 3px 3px 3px;margin-top: 10px;")
            tr
              td
                h4(align="center" style="color: black; margin-top: 5px;") GASTOS FLETE INTERNACIONAL
          table(border="1" width='31%' cellspacing="0" align="center" style='margin-bottom: 15px')
            tr
              td(align="start" style='padding: 0px 4px 0px 4px')
                div
                  span(style='font-size: 11px; color: #000000') FLETE BASE
              td(align="start" style='padding: 0px 4px 0px 4px')
                div
                  span(v-if='datos && datos.fleteOrd' style='font-size: 11px; color: #000000') $ {{datos.fleteOrd}} - {{datos.estatusFlete}}
            tr
              td(align="start" style='padding: 0px 4px 0px 4px')
                div
                  span(style='font-size: 11px; color: #000000') DEPOSITO DE GARANTÍA
              td(align="start" style='padding: 0px 4px 0px 4px')
                div(v-if='datos && datos.gastos && datos.gastos.estatusDepositoG === "No Ex"')
                  span(v-if='datos && datos.gastos && datos.gastos.depositoG'  style='font-size: 11px; color: #000000') $ {{datos.gastos.depositoG}} - {{datos.gastos.estatusDepositoG}}
                div(v-if='datos && datos.gastos && datos.gastos.estatusDepositoG === "Ex"')
                  span(style='font-size: 11px; color: #000000') Exonerado
            tr
              td(align="start" style='padding: 0px 4px 0px 4px; background-color:#26a69a')
                div
                  span(style='font-size: 11px; color: #000000; font-weight: bold') TOTAL
              td(align="start" style='padding: 0px 4px 0px 4px; background-color:#26a69a')
                div
                  span(style='font-size: 11px; color: #000000; font-weight: bold') $ {{totalFlete}}
          table(width='100%' cellspacing="0" align="center" style="padding: 0px 3px 3px 3px;margin-top: -9px;")
            tr
              td
                h4(align="center" style="color: black; margin-top: 5px;") GASTOS LOCALES ORIGEN
          table(v-if='datos && datos.gastos && datos.gastos.gastosLocales' border="1" width='100%' cellspacing="0" align="center")
            tr
              td(align="start" width='40%' style='padding: 0px 0px 0px 4px')
                div
                  span.header DESCRIPCIÓN
              td(align="center" width='8%')
                div
                  span.header COTIZACIÓN
              td(align="start" style='padding: 0px 0px 0px 4px')
                div
                  span.header NOMBRE EMPRESA
              td(align="center" width='12%')
                div
                  span.header NRO. DOCUMENTO
              td(align="center" width='8%')
                div
                  span.header MONTO
              td(align="center" width='8%')
                div
                  span.header ESTATUS
            tr(v-for="(item, k) in datos.gastos.gastosLocales" :key="k" align='center')
              td(align="start" valign='top' style="padding: 5px; color: black; font-size: 11px;")
                div
                  span {{item.descripcion}}
              td(align="center" valign='top' style="padding: 5px; color: black; font-size: 11px;")
                div
                  span $ {{item.cotizacion}}
              td(align="start" valign='top' style="padding: 5px; color: black; font-size: 11px;")
                div
                  span {{item.nombreEmpresa}}
              td(align="start" valign='top' style="padding: 5px; color: black; font-size: 11px;")
                div
                  span {{item.nroDocumento}}
              td(align="center" valign='top' style="padding: 5px; color: black; font-size: 11px;")
                div
                  span $ {{item.monto}}
              td(align="start" valign='top' style="padding: 5px; color: black; font-size: 11px;")
                div
                  span {{item.estatus}}  
          table(width='100%' cellspacing="0" align="center" style="padding: 0px 3px 3px 3px;'margin-top: -9px;")
            tr
              td
                h4(align="center" style="color: black; margin-top: 5px;") GASTOS LOCALES DESTINO
          table(v-if='datos && datos.gastos && datos.gastos.gastosDestino' border="1" width='100%' cellspacing="0" align="center")
            tr
              td(align="start" width='40%' style='padding: 0px 0px 0px 4px')
                div
                  span.header DESCRIPCIÓN
              td(align="center" width='8%')
                div
                  span.header COTIZACIÓN
              td(align="start" style='padding: 0px 0px 0px 4px')
                div
                  span.header NOMBRE EMPRESA
              td(align="center" width='12%')
                div
                  span.header NRO. DOCUMENTO
              td(align="center" width='8%')
                div
                  span.header MONTO
              td(align="center" width='8%')
                div
                  span.header ESTATUS
            tr(v-for="(item, k) in datos.gastos.gastosDestino" :key="k" align='center')
              td(align="start" valign='top' style="padding: 5px; color: black; font-size: 11px;")
                div
                  span {{item.descripcion}}
              td(align="center" valign='top' style="padding: 5px; color: black; font-size: 11px;")
                div
                  span $ {{item.cotizacion}}
              td(align="start" valign='top' style="padding: 5px; color: black; font-size: 11px;")
                div
                  span {{item.nombreEmpresa}}
              td(align="start" valign='top' style="padding: 5px; color: black; font-size: 11px;")
                div
                  span {{item.nroDocumento}}
              td(align="center" valign='top' style="padding: 5px; color: black; font-size: 11px;")
                div
                  span $ {{item.monto}}
              td(align="start" valign='top' style="padding: 5px; color: black; font-size: 11px;")
                div
                  span {{item.estatus}}
          table(width='100%' cellspacing="0" align="center" style="padding: 0px 3px 3px 3px; margin-top: 2px;")
            tr
              td
                h4(align="center" style="color: black; margin-top: 5px;") GASTOS NACIONALIZACIÓN
          table(border="1" width='100%' cellspacing="0" align="center" style="margin-top: 5px;")
            tr(style="color: black;")
              td(align="start" width='30%' style='padding: 0px 0px 0px 4px')
                div
                  span.header BOLIPUERTO/ALMACENADORA
              td(align="start" width='30%' style='padding: 0px 0px 0px 4px')
                div
                  span.header ALCANCES
              td(align="start" width='30%' style='padding: 0px 0px 0px 4px')
                div
                  span.header TASAS E IMPUESTOS
            tr
              td(align="start" valign='top' style='padding: 0px 4px 0px 4px')
                table(width='90%' cellspacing="0" align="center")
                  tr
                    td(align="start" style='padding: 0px 0px 0px 4px')
                      div
                        span(style='font-size: 11px; color: #000000;') # PRELIQUIDACIÓN:
                    td(align="start" style='padding: 0px 0px 0px 4px')
                      div
                        span(v-if='datos && datos.gastos && datos.gastos.preliquidacion' style='font-weight: bold;font-size: 11px; color: #000000') {{datos.gastos.preliquidacion}}
                  tr
                    td(align="start" style='padding: 0px 0px 0px 4px')
                      div
                        span(style='font-size: 11px; color: #000000;') MANEJO DE CARGA:
                    td(align="start" style='padding: 0px 0px 0px 4px')
                      div
                        span(v-if='datos && datos.gastos && datos.gastos.manejoCarga' style='font-weight: bold;font-size: 11px; color: #000000') $ {{datos.gastos.manejoCarga}}
                  tr
                    td(align="start" style='padding: 0px 0px 0px 4px')
                      div
                        span(style='font-size: 11px; color: #000000;') DESPACHO DE CARGA DE CONT:
                    td(align="start" style='padding: 0px 0px 0px 4px')
                      div
                        span(v-if='datos && datos.gastos && datos.gastos.despachoCargaContenedor' style='font-weight: bold;font-size: 11px; color: #000000') $ {{datos.gastos.despachoCargaContenedor}}
                  tr
                    td(align="start" style='padding: 0px 0px 0px 4px')
                      div
                        span(style='font-size: 11px; color: #000000;') SEGURIDAD Y VIGILANCIA:
                    td(align="start" style='padding: 0px 0px 0px 4px')
                      div
                        span(v-if='datos && datos.gastos && datos.gastos.seguridadVigilancia' style='font-weight: bold;font-size: 11px; color: #000000') $ {{datos.gastos.seguridadVigilancia}}
                  tr
                    td(align="start" style='padding: 0px 0px 0px 4px')
                      div
                        span(style='font-size: 11px; color: #000000;') POSICIONAMIENTO:
                    td(align="start" style='padding: 0px 0px 0px 4px')
                      div
                        span(v-if='datos && datos.gastos && datos.gastos.posicionamiento' style='font-weight: bold;font-size: 11px; color: #000000') $ {{datos.gastos.posicionamiento}}
              td(align="center" valign='top' style='padding: 0px 4px 0px 4px')
                table(v-if='datos && datos.gastos && datos.gastos.alcances' width='60%' cellspacing="0" align="center")
                  tr
                    td(align="center")
                      div
                        span.header2 FECHA
                    td(align="center")
                      div
                        span.header2 MONTO
                  tr(v-for="(item, k) in datos.gastos.alcances" :key="k" align='center')
                    td(align="center" valign='top')
                      div
                        span(style='font-size: 11px; color: #000000;') {{item.fecha}}
                    td(align="center" valign='top')
                      div
                        span(style='font-weight: bold;font-size: 11px; color: #000000;') $ {{item.monto}}
              td(align="start" valign='top' style='padding: 0px 4px 0px 4px')
                table(width='90%' cellspacing="0" align="center" style='margin-bottom: 15px')
                  tr
                    td(align="start" style='padding: 0px 0px 0px 4px')
                      div
                        span(style='font-size: 11px; color: #000000;') TASA SERVICIO ADUANA (SENIAT):
                    td(align="start" style='padding: 0px 0px 0px 4px')
                      div
                        span(v-if='datos && datos.gastos && datos.gastos.tasaServicio' style='font-weight: bold;font-size: 11px; color: #000000') $ {{datos.gastos.tasaServicio}}
                  tr
                    td(align="start" style='padding: 0px 0px 0px 4px')
                      div
                        span(style='font-size: 11px; color: #000000;') IMPUESTOS DE IMPORTACIÓN:
                    td(align="start" style='padding: 0px 0px 0px 4px')
                      div
                        span(v-if='datos && datos.gastos && datos.gastos.impuestoImportacion' style='font-weight: bold;font-size: 11px; color: #000000') $ {{datos.gastos.impuestoImportacion}}
                  tr
                    td(align="start" style='padding: 0px 0px 0px 4px')
                      div
                        span(style='font-size: 11px; color: #000000;') IMPUESTO A LAS IMP. ORDINARIAS: 
                    td(align="start" style='padding: 0px 0px 0px 4px')
                      div
                        span(v-if='datos && datos.gastos && datos.gastos.importacionOrdinaria' style='font-weight: bold;font-size: 11px; color: #000000') $ {{datos.gastos.importacionOrdinaria}}
                  tr
                    td(align="start" style='padding: 0px 0px 0px 4px')
                      div
                        span(style='font-size: 11px; color: #000000;') IMPUESTO AL VALOR AGREGADO: 
                    td(align="start" style='padding: 0px 0px 0px 4px')
                      div
                        span(v-if='datos && datos.gastos && datos.gastos.valorAgregadoImportacion' style='font-weight: bold;font-size: 11px; color: #000000') $ {{datos.gastos.valorAgregadoImportacion}}
                  tr
                    td(align="start" style='padding: 0px 0px 0px 4px')
                      div
                        span(style='font-size: 11px; color: #000000;') SERVICIOS DE ADUANA: 
                    td(align="start" style='padding: 0px 0px 0px 4px')
                      div
                        span(v-if='datos && datos.gastos && datos.gastos.servicioAduana' style='font-weight: bold;font-size: 11px; color: #000000') $ {{datos.gastos.servicioAduana}}
                  tr
                    td(align="start" style='padding: 0px 0px 0px 4px')
                      div
                        span(style='font-size: 11px; color: #000000;') ESTAMPILLAS FISCALES:  
                    td(align="start" style='padding: 0px 0px 0px 4px')
                      div
                        span(v-if='datos && datos.gastos && datos.gastos.estampillas' style='font-weight: bold;font-size: 11px; color: #000000') $ {{datos.gastos.estampillas}}
            tr
              td(align="start" style='padding: 1px 0px 0px 4px; background-color:#26a69a')
                b(style='font-size: 12px; padding: 0px 1px 0px 2px; color: #000000;') TOTAL: 
                b(v-if='datos && datos.gastos && datos.gastos.totalPreliquidacion' style='font-size: 12px; font-weight:bold; color:#000000') $ {{datos.gastos.totalPreliquidacion}}
              td(align="start" style='padding: 1px 0px 0px 4px; background-color:#26a69a')
                b(style='font-size: 12px; padding: 0px 1px 0px 2px; color: #000000;') TOTAL: 
                b(v-if='datos && datos.gastos && datos.gastos.totalAlcance' style='font-size: 12px; font-weight:bold; color:#000000') $ {{datos.gastos.totalAlcance}} 
              td(align="start" style='padding: 1px 0px 0px 4px; background-color:#26a69a')
                b(style='font-size: 12px; padding: 0px 1px 0px 2px; color: #000000;') TOTAL: 
                b(v-if='datos && datos.gastos && datos.gastos.totalTasaImpuesto' style='font-size: 12px; font-weight:bold; color:#000000') $ {{datos.gastos.totalTasaImpuesto}}
          table(width='30%' cellspacing="0" align="start" style="padding: 0px 3px 3px 3px;margin-top: 10px;")
            tr
              td
                h4(align="center" style="color: black; margin-top: 5px;margin-bottom: -5px;margin-left: 25px") GASTOS DE ADUANA
          table(width='40%' cellspacing="0" align="center" style="margin-top: 5px;")
            tr
              td(align="start" valign='top' style='padding: 0px 4px 0px 0px')
                table(border="1" width='85%' cellspacing="0" align="center")
                  tr
                    td(align="start" style='padding: 0px 4px 0px 4px' width='30%')
                      div
                        span(style='font-size: 11px; color: #000000;') FLETE TERRESTE
                    td(align="start" style='padding: 0px 4px 0px 4px' width='20%')
                      div
                        span(style='font-weight: bold;font-size: 11px; color: #000000') $ 1.300
                  tr
                    td(align="start" style='padding: 0px 4px 0px 4px')
                      div
                        span(style='font-size: 11px; color: #000000;') SERVICIOS DE AGENCIA ADUANAL
                    td(align="start" style='padding: 0px 4px 0px 4px')
                      div
                        span(style='font-weight: bold;font-size: 11px; color: #000000') $ 2.000
                  tr
                    td(align="start" style='padding: 0px 4px 0px 4px')
                      div
                        span(style='font-size: 11px; color: #000000;') OTROS GASTOS
                    td(align="start" style='padding: 0px 4px 0px 4px')
                      div
                        span(style='font-weight: bold;font-size: 11px; color: #000000') $ 1.200
          table(width='100%' cellspacing="0" align="center" style="margin-top: 10px;")
            tr(style="color: black")
              td(align='start' valign='top' style='padding: 0px 4px 0px 4px; border-right: 0px')
                h4
                  u TOTALES
                table(border="0" width='95%' cellspacing="0" align="center" style='margin-bottom: 5px;')
                  tr
                    td(align="start")
                      div
                        span.header2 TOTAL ORDENES DE COMPRA FOB:  
                    td(align="start")
                      div
                        span(v-if='datos && datos.totalGeneralOrd' style='font-size: 12px; font-weight:bold;') $ {{datos.totalGeneralOrd}}
                  tr
                    td(align="start")
                      div
                        span.header2 TOTAL FLETE INTERNACIONAL: 
                    td(align="start")
                      div
                        span(style='font-size: 12px;font-weight:bold;') $ {{totalFleteInternacional}}
                  tr
                    td(align="start")
                      div
                        span.header2 TOTAL GASTOS NACIONALIZACIÓN: 
                    td(align="start")
                      div
                        span(style='font-size: 12px;font-weight:bold;') $ {{totalGastoNacinalizacion}}
              td(style='border-left: 0px; border-right: 0px' width='35%')
              td(style='border-left: 0px')
                table(border="0" width='95%' cellspacing="0" align="end" style='margin-bottom: 5px;')
                  tr
                    br
                  tr
                    br
                  tr
                    td(align="center" style='padding: 0px 4px 0px 4px; background-color:#26a69a; border: 1px solid #000000; border-right: 0px;')
                      div
                        span.header2 TOTAL GENERAL IMPORTACIÓN: 
                    td(align="center" style='padding: 0px 8px;background-color:#26a69a; border: 1px solid #000000; border-left: 0px;')
                      div
                        span.header2(style='font-size: 12px;') $ {{totalGeneralImportacion}} 
                  tr 
                    td(align="center" style='padding: 0px 4px 0px 4px; border-right: 0px; background-color:#26a69a; border: 1px solid #000000')
                      div
                        span.header2 PROMEDIO DE GASTOS: 
                    td(align="center" style='padding: 0px 8px; border-left: 0px; background-color:#26a69a; border: 1px solid #000000')
                      div
                        span.header2(style='font-size: 12px;') $ {{promedio}}      
      v-card-actions
        v-btn(color='error' small dark @click='closeExpediente')
          v-icon mdi-close
          | Cancelar
        v-spacer
        v-btn(color='success' small dark @click="imprimir()")
          v-icon mdi-content-save
          | Imprimir     
</template>

<script>
import printJS from 'print-js'
import { EventBus } from '../../Events'
export default {
  name: 'Expediente',
  props: ['dialogImportacionExpediente'],
  data: () => ({
    fechaActual: '',
    datos: {},
    valor: 0,
    totalFlete: 0,
    totalFleteInternacional: 0,
    totalGastoNacinalizacion: 0,
    totalGeneralImportacion: 0,
    promedio: 0
  }),
  
  watch: {},

  created () {
    EventBus.$on('expedienteImportacion', data => {
      console.log('DATA', data)
      this.datos = data
      this.valor = this.datos.contenedores.length
      var today = new Date()
      this.fechaActual = this.$moment(today).format('YYYY-MM-DD')
      // para tabla de ordenes de compra
      if (this.datos && this.datos.importacion && this.datos.importacion) {
        this.datos.importacion.map(impor => {
          impor.totalOrd = parseFloat(impor.totalOrd)
          impor.totalOrd = (impor.totalOrd).toFixed(2)
        })
      }
      // para tabla de contenedores
      this.datos.kilogramosGeneralContenedor ? this.datos.kilogramosGeneralContenedor = parseFloat(this.datos.kilogramosGeneralContenedor) : this.datos.kilogramosGeneralContenedor = 0
      this.datos.piesCubicosGeneralContenedor ? this.datos.piesCubicosGeneralContenedor = parseFloat(this.datos.piesCubicosGeneralContenedor) : this.datos.piesCubicosGeneralContenedor = 0
      this.datos.kilogramosGeneralContenedor = (this.datos.kilogramosGeneralContenedor).toFixed(2)
      this.datos.piesCubicosGeneralContenedor = (this.datos.piesCubicosGeneralContenedor).toFixed(2)
      // Gastos Flete Internacional
      this.datos.fleteOrd ? this.datos.fleteOrd = parseFloat(this.datos.fleteOrd) : this.datos.fleteOrd = 0
      this.datos.gastos.depositoG ? this.datos.gastos.depositoG = parseFloat(this.datos.gastos.depositoG) : this.datos.gastos.depositoG = 0
      this.datos.gastos.gastoMontoTotal ? this.datos.gastos.gastoMontoTotal = parseFloat(this.datos.gastos.gastoMontoTotal) : this.datos.gastos.gastoMontoTotal = 0
      this.totalFlete = this.datos.fleteOrd + ( (this.datos.gastos.estatusDepositoG && this.datos.gastos.estatusDepositoG === 'No Ex') ? this.datos.gastos.depositoG : 0 )
      // Gastos Internacionalizacion
      this.datos.gastos.preliquidacion ? this.datos.gastos.preliquidacion = parseFloat(this.datos.gastos.preliquidacion) : this.datos.gastos.preliquidacion = 0
      this.datos.gastos.manejoCarga ? this.datos.gastos.manejoCarga = parseFloat(this.datos.gastos.manejoCarga) : this.datos.gastos.manejoCarga = 0
      this.datos.gastos.despachoCargaContenedor ? this.datos.gastos.despachoCargaContenedor = parseFloat(this.datos.gastos.despachoCargaContenedor) : this.datos.gastos.despachoCargaContenedor = 0
      this.datos.gastos.seguridadVigilancia ? this.datos.gastos.seguridadVigilancia = parseFloat(this.datos.gastos.seguridadVigilancia) : this.datos.gastos.seguridadVigilancia = 0
      this.datos.gastos.posicionamiento ? this.datos.gastos.posicionamiento = parseFloat(this.datos.gastos.posicionamiento) : this.datos.gastos.posicionamiento = 0
      this.datos.gastos.totalPreliquidacion ? this.datos.gastos.totalPreliquidacion = parseFloat(this.datos.gastos.totalPreliquidacion) : this.datos.gastos.totalPreliquidacion = 0
      // Alcances
      if (this.datos && this.datos.gastos && this.datos.gastos.alcances) {  
        this.datos.gastos.alcances.map(alc => {
          alc.monto = parseFloat(alc.monto)
          alc.monto = (alc.monto).toFixed(2)
        })
      }
      this.datos.gastos.totalAlcance ? this.datos.gastos.totalAlcance = parseFloat(this.datos.gastos.totalAlcance) : this.datos.gastos.totalAlcance = 0
      // Tasa e Impuestos
      this.datos.gastos.tasaServicio ? this.datos.gastos.tasaServicio = parseFloat(this.datos.gastos.tasaServicio) : this.datos.gastos.tasaServicio = 0
      this.datos.gastos.impuestoImportacion ? this.datos.gastos.impuestoImportacion = parseFloat(this.datos.gastos.impuestoImportacion) : this.datos.gastos.impuestoImportacion = 0
      this.datos.gastos.importacionOrdinaria ? this.datos.gastos.importacionOrdinaria = parseFloat(this.datos.gastos.importacionOrdinaria) : this.datos.gastos.importacionOrdinaria = 0
      this.datos.gastos.valorAgregadoImportacion ? this.datos.gastos.valorAgregadoImportacion = parseFloat(this.datos.gastos.valorAgregadoImportacion) : this.datos.gastos.valorAgregadoImportacion = 0
      this.datos.gastos.servicioAduana ? this.datos.gastos.servicioAduana = parseFloat(this.datos.gastos.servicioAduana) : this.datos.gastos.servicioAduana = 0
      this.datos.gastos.estampillas ? this.datos.gastos.estampillas = parseFloat(this.datos.gastos.estampillas) : this.datos.gastos.estampillas = 0
      this.datos.gastos.totalTasaImpuesto ? this.datos.gastos.totalTasaImpuesto = parseFloat(this.datos.gastos.totalTasaImpuesto) : this.datos.gastos.totalTasaImpuesto = 0
      // Totales
      this.datos.totalGeneralOrd ? this.datos.totalGeneralOrd = parseFloat(this.datos.totalGeneralOrd) : this.datos.totalGeneralOrd = 0
      this.totalFleteInternacional = parseFloat(this.totalFlete) + parseFloat(this.datos.gastos.gastoMontoTotal)
      this.totalGastoNacinalizacion = parseFloat(this.datos.gastos.totalPreliquidacion) + parseFloat(this.datos.gastos.totalAlcance) + parseFloat(this.datos.gastos.totalTasaImpuesto)
      this.totalGeneralImportacion = parseFloat(this.datos.totalGeneralOrd) + parseFloat(this.totalGastoNacinalizacion) + parseFloat(this.totalFleteInternacional)
      if (this.datos.totalGeneralOrd !== 0) { this.promedio = (parseFloat(this.totalFleteInternacional) + parseFloat(this.totalGastoNacinalizacion )) / this.datos.totalGeneralOrd }
      // ToFixed
      this.datos.fleteOrd = (this.datos.fleteOrd).toFixed(2)
      this.datos.gastos.depositoG = (this.datos.gastos.depositoG).toFixed(2)
      this.datos.gastos.manejoCarga = (this.datos.gastos.manejoCarga).toFixed(2)
      this.datos.gastos.despachoCargaContenedor = (this.datos.gastos.despachoCargaContenedor).toFixed(2)
      this.datos.gastos.seguridadVigilancia = (this.datos.gastos.seguridadVigilancia).toFixed(2)
      this.datos.gastos.posicionamiento = (this.datos.gastos.posicionamiento).toFixed(2)
      this.datos.gastos.totalPreliquidacion = (this.datos.gastos.totalPreliquidacion).toFixed(2)
      this.datos.gastos.totalAlcance = (this.datos.gastos.totalAlcance).toFixed(2)
      this.datos.gastos.tasaServicio = (this.datos.gastos.tasaServicio).toFixed(2)
      this.datos.gastos.impuestoImportacion = (this.datos.gastos.impuestoImportacion).toFixed(2)
      this.datos.gastos.importacionOrdinaria = (this.datos.gastos.importacionOrdinaria).toFixed(2)
      this.datos.gastos.valorAgregadoImportacion = (this.datos.gastos.valorAgregadoImportacion).toFixed(2)
      this.datos.gastos.servicioAduana = (this.datos.gastos.servicioAduana).toFixed(2)
      this.datos.gastos.estampillas = (this.datos.gastos.estampillas).toFixed(2)
      this.datos.gastos.totalTasaImpuesto = (this.datos.gastos.totalTasaImpuesto).toFixed(2)
      this.datos.totalGeneralOrd = (this.datos.totalGeneralOrd).toFixed(2) // Totales generales
      this.totalFleteInternacional = (this.totalFleteInternacional).toFixed(2)
      this.totalGastoNacinalizacion = (this.totalGastoNacinalizacion).toFixed(2)
      this.totalGeneralImportacion = (this.totalGeneralImportacion).toFixed(2)
      this.promedio = (this.promedio).toFixed(2)
    })
  },

  methods: {
    imprimir () {
      printJS({
        printable: 'expediente',
        type: 'html',
        targetStyles: ['*'],
        maxWidth: '100%',
        documentTitle: 'Expediente'
      })
      this.closeExpediente()
    },

    closeExpediente () {
      this.$emit('closeExpediente')
    },

  }
}
</script>

<style lang="scss">
  #expediente {
    .header {
      font-size: 11px;
      color: black;
      font-weight: bold;
    }
    .header2 {
      font-size: 12px;
      color: black;
      font-weight: bold;
    }
  }
</style>
